import { ConfigPatientView as Patient } from './Patient';
import { ConfigOverviewView as PatientOverview } from './Overview';
import  CreateUpdatePatient  from './CreateUpdate';
import { ConfigCreateModalView as CreatePatientModal } from './CreateModal';

export { PatientOverview, CreateUpdatePatient, CreatePatientModal };
export default Patient;
